<template>
  <el-container>
  <el-aside style="height: 100vh;width: auto;"
  class="backcolor"
  >
        <Menu></Menu>
  </el-aside>
  <el-container>
    <el-header style="padding: 0;height: auto;">
        <Header></Header>
    </el-header>
    <el-main style="background-color: #ccc;height: 100%; padding: 5px;">
        <router-view></router-view>
    </el-main>
  </el-container>
</el-container>
</template>

<script>
import Menu  from '@/views/layout/menu'
import Header  from '@/views/layout/content/header.vue'
export default {
    components:{
        Menu,
        Header
    }
}
</script>
<style lang="scss" scoped>


.backcolor {
    background-color: $menu-back-color;
    
  }

</style>
